export const EMAILS_FETCH_MANY_REQUEST = 'EMAILS_FETCH_MANY_REQUEST'
export const EMAILS_FETCH_MANY_SUCCESS = 'EMAILS_FETCH_MANY_SUCCESS'
export const EMAILS_FETCH_MANY_FAILURE = 'EMAILS_FETCH_MANY_FAILURE'

export const EMAILS_FETCH_REQUEST = 'EMAILS_FETCH_REQUEST'
export const EMAILS_FETCH_SUCCESS = 'EMAILS_FETCH_SUCCESS'
export const EMAILS_FETCH_FAILURE = 'EMAILS_FETCH_FAILURE'
